<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicle Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/Svehicleinvoice/Index">Manage Vehicle Invoice   </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{all_data.invoice_num }} </h6>
                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                
                  <button v-if="all_data.statusvalue==3"  @click="Createso()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad">  Create Receipt</button>
                  
                  <button v-if="all_data.statusvalue==1"  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                  <button v-if="all_data.statusvalue==1"  @click="Confimmodel()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                  <button   @click="generatePDF()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
                
                  <!-- v-if="all_data.status!=1" -->
            
                </div>
                <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>

  <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                  <div >


                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Invoice Number </b></td>
                           <td>{{ all_data.invoice_num }}</td> 
                          </tr>
                          <tr>
                            <td><b>Sales Order</b></td>
                            <td>{{ all_data.so_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>Customer</b></td>
                           <td>{{ all_data.user_full_name }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Dealer</b></td>
                           <td>{{ all_data.C_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Sales Rep. </b></td>
                           <td>{{ all_data.name1 }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Make</b></td>
                           <td>{{ all_data.brandname }}</td> 
                          </tr>
                          <tr>
                            <td><b>Model</b></td>
                           <td>{{ all_data.modelname }} </td> 
                          </tr>
                          <tr>
                            <td><b>Color </b></td>
                           <td>{{ all_data.colorcode }}</td> 
                          </tr>
                          <tr>
                            <td><b>Engine No. </b></td>
                           <td>{{ all_data.engineno }}</td> 
                          </tr>
                          <tr>
                            <td><b>Chassis No.</b></td>
                           <td>{{ all_data.chassisno }}</td> 
                          </tr>
                          <tr>
                            <td><b>Issued Accessories</b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Invoice Date</b></td>
                           <td>{{ all_data.invoice_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Invoice Amount (Rs)</b></td>
                           <td>{{ all_data.invoice_amount }}</td> 
                          </tr>
                          <tr>
                            <td><b>Discount Amount (Rs)</b></td>
                           <td>{{ all_data.discount_amount }}</td> 
                          </tr>
                          <tr>
                            <td><b>Leasing PO (Rs)</b></td>
                           <td>{{ all_data.leasing_po }}</td> 
                          </tr>
                          <tr>
                            <td><b>Advance Amount (Rs)</b></td>
                           <td>{{ all_data.received_advance }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Invoice Chargeable Amount (Rs)</b></td>
                           <td>{{ all_data.total_chargeble_amount }}</td> 
                          </tr>
                          <tr>
                            <td><b>Paid Amount (Rs)</b></td>
                           <td>{{ all_data.paid_amount }}</td> 
                          </tr>
                          <tr>
                            <td><b>Balance Payable (Rs)</b></td>
                           <td>{{ all_data.balnce }}</td> 
                          </tr>
                          <tr>
                            <td><b>Remarks</b></td>
                           <td>{{ all_data.remarks }}</td> 
                          </tr>
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ all_data.status1 }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ all_data.created_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created By</b></td>
                           <td>{{ all_data.username }}</td> 
                          </tr>

                        
                       
                          
                         
                           
                        </tbody>
                 
                 
                      </table>



                     
                      </div>
                      </div>










                   



                    <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

                  
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                <thead class="background_color2">
                  <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(mservicelog, index) in mservicelogs" :key="mservicelog.idServicelog">
                    <td>{{index+1}}</td>
                    <td>{{ mservicelog.comments }}</td>
                    <td>{{ mservicelog.job_type }}</td>
                    <td>{{ mservicelog.created_date }}</td>
                    <td>{{ mservicelog.relatedToUser.username }}</td>
                    <td>{{ mservicelog.followup_date }}</td>
                    <td>{{ mservicelog.relatedToFollowupby.username }}</td>
                  
                    
                    </tr>
                  </tbody>

                </table>


     

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select" v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Vehicle Sales</option>
                              <option  >Spare Parts Sales</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control" disabled>
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Add CRM Note</button>
                </div>
                </div>

            </div>
        </div>


        <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                          <thead class="background_color2">
                            <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>


                        </div>
                    </div>




   

<br><br>





                




                </div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
    import vSelect from 'vue-select';
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSquatation()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            'id':this.$route.query.id,
           
            all_data:{},
            payment:{},
            total:{},
           
           
            status:{},
            leasing:{},
            user:{},
            uploadname:{},
            banks:[],
            crm:{},
            details:[],
            datatrans:[],
            mservicelogs:[],
            receipts:[],
            trans:[],
            width:5,
            height:5,
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        chequ:false,

        paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: 'Cheque', value: 'Cheque' },
            // Add more options as needed
        ],

        // imageUrl: '/img/evenware-logo.png' 
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

            generatePDF() {
    
    const doc = new jsPDF();

    function addPageBorders(doc) {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  // Set the border style
  doc.setDrawColor(71, 144, 255); // Black color
  doc.setLineWidth(15); // Border width

  // Draw a line at the top of the page
  doc.line(0, 0, pageWidth, 0);
  // Draw a line at the bottom of the page
  doc.line(0, pageHeight, pageWidth, pageHeight);
}
   // Update this with your image URL or file path
 
    var img = new Image()
  img.src = '/img/evenware-logo.png'
  const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed

doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
doc.setFontSize(18);
doc.setFont('Helvetica', 'bold');
doc.text('PROFORMA', 105, 30, null, null, 'center');
doc.setFontSize(12);

doc.text('Demonstration System', 10, 45, null, null);

doc.setFont('Helvetica', 'normal');
doc.setFontSize(8);
doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
doc.text('Nawala Road,', 10, 51, null, null);
doc.text('Rajagiriya,', 10, 54, null, null);
doc.text('Colombo 08,', 10, 57, null, null);
doc.text('Sri Lanka', 10, 60, null, null);
doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('INVOICE To:', 85, 45, null, null);
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data.user_full_name, 85, 48, null, null);
doc.text(this.all_data.user_address_line1, 85, 51, null, null);









doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('INVOICE:', 200, 45, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data.invoice_num, 200, 49, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Order:', 200, 53, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data.so_code, 200, 56, null, null, 'right');


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Person:', 200, 60, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data.name1, 200, 63, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Dealer:', 200, 67, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data.C_name, 200, 70, null, null, 'right');






doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Date:', 200, 74, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data.invoice_date, 200, 77, null, null, 'right');

const tableData = [
      ['No', 'DESCRIPTION', 'UNIT PRICE', 'TOTAL AMOUNT']
  ];



  

  this.details.forEach(detail => {
      tableData.push([
          detail.no,
         detail.description,
           detail.customer_price, 
         
       
            detail.customer_price, 
         
         
        
      ]);
  });



// Use jsPDF and autoTable


      // Add table to the PDF
      doc.autoTable({
          startY: 85, // Y position to start the table
          head: [tableData[0]], // Table header
          body: tableData.slice(1),
          addPageContent: function(data) {
      addPageBorders(doc); // Call the function to add page borders
  },
  styles: {
      font: 'Helvetica',
      fontSize:8,
  },
          // Table data excluding header
      });

      
      const tableBottomY = doc.lastAutoTable.finalY;

      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('Total: '+this.total, 195, tableBottomY+10, null, null, 'right');

      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text(' Discount: '+this.all_data.discount_amount, 195, tableBottomY+18, null, null, 'right');

      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('Leasing PO :'+this.all_data.leasing_po, 195, tableBottomY+26, null, null, 'right');
      
      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('Advance :'+this.all_data.received_advance, 195, tableBottomY+34, null, null, 'right');
      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('Balance Payable :'+this.all_data.balnce, 195, tableBottomY+42, null, null, 'right');

      doc.setFontSize(9);
      doc.setFont('Helvetica', 'normal');
      doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+65, null, null);
      doc.text('* Settlement should be made within 5 days', 10, tableBottomY+70, null, null);
      doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+75, null, null);
      doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+80, null, null);
      doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+85, null, null);
      doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+90, null, null);


      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('.........................................', 10, tableBottomY+120, null, null);
      doc.text('ISSUED BY', 20, tableBottomY+125, null, null);

      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('.....................................................', 50, tableBottomY+120, null, null);
      doc.text('DEALER SIGNATURE ', 57, tableBottomY+125, null, null);

      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('.....................................................', 100, tableBottomY+120, null, null);
      doc.text('AUTHORIZED BY  ', 110, tableBottomY+125, null, null);
    
      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('.....................................................', 150, tableBottomY+120, null, null);
      doc.text('APPROVED BY  ', 160, tableBottomY+125, null, null);
      



      doc.output('dataurlnewwindow');



  },





          
    async selectmode(){
      if(this.payment.payment_mode['value']=="Cheque"){
           
         
           this.chequ = true;
         }else if(this.payment.payment_mode['value']=="Cash"){
          this.chequ = false;
         }


      },



    async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },



          async Confirm(id) {
       
    
       try {
         const { data} = await  axios.get('/spfi/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },


     async addCreate() {
       
    
       try {
         const { data} = await  axios.post('/svehiclesalesorder/addcreate?id='+this.id,{payment:this.payment,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     async crmCreate() {
       
    
       try {
         const { data} = await  axios.post('/svehicleinvoice/crmcreate?id='+this.id,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },



    

     async loadSquatation() {
  
      try {
        const { data} = await  axios.get('/svehicleinvoice/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_data = data.all_data
          this.details = data.details
          this.total = data.total
           this.mservicelogs = data.mservicelogs
        //   this.banks = data.banks
        //   this.receipts = data.receipts
        //   this.leasing = data.leasing
        // 
       
       
        
      } catch (error) {
        console.log(error.response);
      }
    },


    async Update(){
        this.$router.push('/svehiclesalesorder/update?id='+this.id);
      },
   

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>